import Header from '../layout/Header/Header';
import Main from '../layout/Main/Main';
import Footer from '../layout/Footer/Footer';

export default function HomePage() {
  return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
  );
}
